module.exports = __webpack_public_path__ + "162bf967f7963e60f328084ff30318d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/img/shengdi/xinshang/xinshang-bg.jpg
// module id = 1235
// module chunks = 0